import styled from "styled-components";
import { getColor } from "views/resources/theme";

export const LabelButtonStyled = styled.button`
	display: ${(props) => (props.desktop ? "inline-block" : "flex")};
	border: none;
	background: transparent;
	color: ${getColor("blue_hover")};
	padding: 0;
	min-width: 120px;
	:hover {
		cursor: pointer;
	}
	span {
		font-size: 14px;
		font-weight: 600;
	}
	text-align: left;
`;
